export const byFundKey = (accountId: string, isin: string): string =>
  `${accountId}-${isin}`;
